import { render, staticRenderFns } from "./PortionTypeSelect.vue?vue&type=template&id=5cbdf762&"
import script from "./PortionTypeSelect.vue?vue&type=script&lang=js&"
export * from "./PortionTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./PortionTypeSelect.vue?vue&type=style&index=0&id=5cbdf762&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports